import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardTimePicker,
  type KeyboardTimePickerProps,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import React from "react";
import HelperText, { type ErrorMessage } from "./HelperText";

export interface TimePickerProps
  extends Omit<KeyboardTimePickerProps, "error"> {
  error?: string | ErrorMessage;
  helperText?: string;
}

function TimePicker(props: TimePickerProps): React.ReactElement {
  const {
    helperText = null,
    error,
    name,
    autoOk = true,
    disableToolbar = true,
    variant = "inline",
    label = null,
    required = undefined,
    ...rest
  } = props;

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardTimePicker
        {...rest}
        label={label}
        required={required}
        variant={variant}
        autoOk={autoOk}
        disableToolbar={disableToolbar}
        name={name}
        id={name}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
        InputLabelProps={{ htmlFor: name, "aria-labelledby": name }}
        error={!!error}
        helperText={<HelperText error={error}>{helperText}</HelperText>}
      />
    </MuiPickersUtilsProvider>
  );
}

export default TimePicker;
